export const MostCommonLanguages = new Set([
    "es",
    "en",
    "fr",
    "de",
    "pt",
    "ja",
    "it",
    "ru",
    "tr",
    "ko",
    "ar",
    "nl",
    "uk",
    "zh-Hans",
    "zh-Hant",
    "sv",
    "id",
    "th",
    "vi",
    "pl",
    "zh",
    "da",
    "ko-Kore",
    "fi",
    "hi",
    "nb",
    "hu",
    "ms",
    "cs",
    "ro",
    "he",
    "hr",
    "ca",
    "sk",
    "el",
    "pt_BR",
    "pt-br",
    "lt",
    "af",
    "be",
    "bg",
    "no",
    "fa",
    "pt_PT",
    "gu"
]);
export const languagesWithoutisRTL = {
    en: {
        locale: "en",
        displayName: "English"
    },
    es: {
        locale: "es",
        displayName: "Spanish"
    },
    pt: {
        locale: "pt",
        displayName: "Portuguese (Any)"
    },
    pt_BR: {
        locale: "pt_BR",
        displayName: "Portuguese (Brazil)"
    },
    pt_PT: {
        locale: "pt_PT",
        displayName: "Portuguese (Portugal)"
    },
    fr: {
        locale: "fr",
        displayName: "French"
    },
    it: {
        locale: "it",
        displayName: "Italian"
    },
    da: {
        locale: "da",
        displayName: "Danish"
    },
    tr: {
        locale: "tr",
        displayName: "Turkish"
    },
    uk: {
        locale: "uk",
        displayName: "Ukrainian"
    },
    nl: {
        locale: "nl",
        displayName: "Dutch"
    },
    ru: {
        locale: "ru",
        displayName: "Russian"
    },
    ar: {
        locale: "ar",
        displayName: "Arabic"
    },
    zh: {
        locale: "zh",
        displayName: "Chinese"
    },
    de: {
        locale: "de",
        displayName: "German"
    },
    hr: {
        locale: "hr",
        displayName: "Croatian"
    },
    he: {
        locale: "he",
        displayName: "Hebrew"
    },
    sv: {
        locale: "sv",
        displayName: "Swedish"
    },
    el: {
        locale: "el",
        displayName: "Greek"
    },
    fi: {
        locale: "fi",
        displayName: "Finnish"
    },
    ja: {
        locale: "ja",
        displayName: "Japanese"
    },
    ro: {
        locale: "ro",
        displayName: "Romanian"
    },
    hu: {
        locale: "hu",
        displayName: "Hungarian"
    },
    pl: {
        locale: "pl",
        displayName: "Polish"
    },
    "ko-Kore": {
        locale: "ko-Kore",
        displayName: "Korean"
    },
    th: {
        locale: "th",
        displayName: "Thai"
    },
    cs: {
        locale: "cs",
        displayName: "Czech"
    },
    "zh-Hans": {
        locale: "zh-Hans",
        displayName: "Chinese Simplified"
    },
    id: {
        locale: "id",
        displayName: "Indonesian"
    },
    "zh-Hant": {
        locale: "zh-Hant",
        displayName: "Chinese Traditional"
    },
    ms: {
        locale: "ms",
        displayName: "Malay"
    },
    rar: {
        locale: "rar",
        displayName: "Rarotongan"
    },
    vi: {
        locale: "vi",
        displayName: "Vietnamese"
    },
    sk: {
        locale: "sk",
        displayName: "Slovak"
    },
    no: {
        locale: "no",
        displayName: "Norwegian"
    },
    nb: {
        locale: "nb",
        displayName: "Norwegian Bokmål"
    },
    km: {
        locale: "km",
        displayName: "Khmer"
    },
    "ckb-Arab": {
        locale: "ckb-Arab",
        displayName: "Kurdish Sorani"
    },
    "sr-Latn": {
        locale: "sr-Latn",
        displayName: "Serbian Latin"
    },
    ale: {
        locale: "ale",
        displayName: "Aleut"
    },
    ka: {
        locale: "ka",
        displayName: "Georgian"
    },
    ca: {
        locale: "ca",
        displayName: "Catalan"
    },
    fa: {
        locale: "fa",
        displayName: "Persian"
    },
    sq: {
        locale: "sq",
        displayName: "Albanian"
    },
    hy: {
        locale: "hy",
        displayName: "Armenian"
    },
    ars: {
        locale: "ars",
        displayName: "Najdi Arabic"
    },
    rw: {
        locale: "rw",
        displayName: "Kinyarwanda"
    },
    bg: {
        locale: "bg",
        displayName: "Bulgarian"
    },
    "sm-Latn": {
        locale: "sm-Latn",
        displayName: "Samoan Latin"
    },
    tlh: {
        locale: "tlh",
        displayName: "Klingon"
    },
    ks: {
        locale: "ks",
        displayName: "Kashmiri"
    },
    lt: {
        locale: "lt",
        displayName: "Lithuanian"
    },
    wo: {
        locale: "wo",
        displayName: "Wolof"
    },
    haw: {
        locale: "haw",
        displayName: "Hawaiian"
    },
    so: {
        locale: "so",
        displayName: "Somali"
    },
    sr: {
        locale: "sr",
        displayName: "Serbian"
    },
    yue: {
        locale: "yue",
        displayName: "Cantonese"
    },
    "iu-Cans": {
        locale: "iu-Cans",
        displayName: "Inuktitut"
    },
    az: {
        locale: "az",
        displayName: "Azerbaijani"
    },
    lo: {
        locale: "lo",
        displayName: "Lao"
    },
    sl: {
        locale: "sl",
        displayName: "Slovenian"
    },
    mk: {
        locale: "mk",
        displayName: "Macedonian"
    },
    pa: {
        locale: "pa",
        displayName: "Punjabi"
    },
    gsw: {
        locale: "gsw",
        displayName: "Swiss German"
    },
    et: {
        locale: "et",
        displayName: "Estonian"
    },
    rup: {
        locale: "rup",
        displayName: "Aromanian"
    },
    "ms-Arab": {
        locale: "ms-Arab",
        displayName: "Malay Arabic"
    },
    be: {
        locale: "be",
        displayName: "Belarusian"
    },
    my: {
        locale: "my",
        displayName: "Burmese"
    },
    "kac-Latn": {
        locale: "kac-Latn",
        displayName: "Kachin Latin"
    },
    "snk-Arab": {
        locale: "snk-Arab",
        displayName: "Soninke Arabic"
    },
    kk: {
        locale: "kk",
        displayName: "Kazakh"
    },
    lv: {
        locale: "lv",
        displayName: "Latvian"
    },
    "bug-Latn": {
        locale: "bug-Latn",
        displayName: "Buginese Latin"
    },
    "pa-Aran": {
        locale: "pa-Aran",
        displayName: "Punjabi Arabic"
    },
    zu: {
        locale: "zu",
        displayName: "Zulu"
    },
    rap: {
        locale: "rap",
        displayName: "Rapa Nui"
    },
    mn: {
        locale: "mn",
        displayName: "Mongolian"
    },
    dv: {
        locale: "dv",
        displayName: "Divehi"
    },
    "jv-Latn": {
        locale: "jv-Latn",
        displayName: "Javanese Latin"
    },
    hi: {
        locale: "hi",
        displayName: "Hindi"
    },
    "os-Cyrl": {
        locale: "os-Cyrl",
        displayName: "Ossetic Cyrillic"
    },
    "uz-Arab": {
        locale: "uz-Arab",
        displayName: "Uzbek Arabic"
    },
    lb: {
        locale: "lb",
        displayName: "Luxembourgish"
    },
    anp: {
        locale: "anp",
        displayName: "Angika"
    },
    is: {
        locale: "is",
        displayName: "Icelandic"
    },
    la: {
        locale: "la",
        displayName: "Latin"
    },
    ain: {
        locale: "ain",
        displayName: "Ainu"
    },
    gl: {
        locale: "gl",
        displayName: "Galician"
    },
    ps: {
        locale: "ps",
        displayName: "Pashto"
    },
    mt: {
        locale: "mt",
        displayName: "Maltese"
    },
    "ks-Arab": {
        locale: "ks-Arab",
        displayName: "Kashmiri Arabic"
    },
    "ksh-Latn": {
        locale: "ksh-Latn",
        displayName: "Colognian Latin"
    },
    ko: {
        locale: "ko",
        displayName: "Korean"
    },
    "ht-Latn": {
        locale: "ht-Latn",
        displayName: "Haitian Latin"
    },
    "bho-Deva": {
        locale: "bho-Deva",
        displayName: "Bhojpuri Devanagari"
    },
    "mn-Mong": {
        locale: "mn-Mong",
        displayName: "Mongolian Mongolian"
    },
    sa: {
        locale: "sa",
        displayName: "Sanskrit"
    },
    bn: {
        locale: "bn",
        displayName: "Bengali"
    },
    af: {
        locale: "af",
        displayName: "Afrikaans"
    },
    cy: {
        locale: "cy",
        displayName: "Welsh"
    },
    fil: {
        locale: "fil",
        displayName: "Filipino"
    },
    "su-Latn": {
        locale: "su-Latn",
        displayName: "Sundanese Latin"
    },
    fo: {
        locale: "fo",
        displayName: "Faroese"
    },
    ml: {
        locale: "ml",
        displayName: "Malayalam"
    },
    bs: {
        locale: "bs",
        displayName: "Bosnian"
    },
    uz: {
        locale: "uz",
        displayName: "Uzbek"
    },
    "pap-Latn": {
        locale: "pap-Latn",
        displayName: "Papiamento Latin"
    },
    to: {
        locale: "to",
        displayName: "Tongan"
    },
    "pa-Arab": {
        locale: "pa-Arab",
        displayName: "Punjabi Arabic"
    },
    "bs-Cyrl": {
        locale: "bs-Cyrl",
        displayName: "Bosnian Cyrillic"
    },
    "mh-Latn": {
        locale: "mh-Latn",
        displayName: "Marshallese Latin"
    },
    "shn-Mymr": {
        locale: "shn-Mymr",
        displayName: "Shan Myanmar"
    },
    "ceb-Latn": {
        locale: "ceb-Latn",
        displayName: "Cebuano Latin"
    },
    "srn-Latn": {
        locale: "srn-Latn",
        displayName: "Sranan Tongo Latin"
    },
    ak: {
        locale: "ak",
        displayName: "Akan"
    },
    "ks-Deva": {
        locale: "ks-Deva",
        displayName: "Kashmiri Devanagari"
    },
    "ce-Cyrl": {
        locale: "ce-Cyrl",
        displayName: "Chechen Cyrillic"
    },
    "chk-Latn": {
        locale: "chk-Latn",
        displayName: "Chuukese Latin"
    },
    am: {
        locale: "am",
        displayName: "Amharic"
    },
    ne: {
        locale: "ne",
        displayName: "Nepali"
    },
    lus: {
        locale: "lus",
        displayName: "Mizo"
    },
    "sah-Cyrl": {
        locale: "sah-Cyrl",
        displayName: "Yakut Cyrillic"
    },
    ky: {
        locale: "ky",
        displayName: "Kyrgyz"
    },
    xal: {
        locale: "xal",
        displayName: "Kalmyk"
    },
    ga: {
        locale: "ga",
        displayName: "Irish"
    },
    "kha-Latn": {
        locale: "kha-Latn",
        displayName: "Khasi Latin"
    },
    ur: {
        locale: "ur",
        displayName: "Urdu"
    },
    "cv-Cyrl": {
        locale: "cv-Cyrl",
        displayName: "Chuvash Cyrillic"
    },
    "mak-Latn": {
        locale: "mak-Latn",
        displayName: "Makasar Latin"
    },
    tg: {
        locale: "tg",
        displayName: "Tajik"
    },
    rn: {
        locale: "rn",
        displayName: "Rundi"
    },
    ig: {
        locale: "ig",
        displayName: "Igbo"
    },
    "az-Cyrl": {
        locale: "az-Cyrl",
        displayName: "Azerbaijani Cyrillic"
    },
    "mi-Latn": {
        locale: "mi-Latn",
        displayName: "Maori Latin"
    },
    si: {
        locale: "si",
        displayName: "Sinhala"
    },
    "lkt-Latn": {
        locale: "lkt-Latn",
        displayName: "Lakota Latin"
    },
    mfe: {
        locale: "mfe",
        displayName: "Mauritian Creole"
    },
    "ts-Latn": {
        locale: "ts-Latn",
        displayName: "Tsonga Latin"
    },
    mic: {
        locale: "mic",
        displayName: "Micmac"
    },
    "my-Qaag": {
        locale: "my-Qaag",
        displayName: "Burmese Qaag"
    },
    "ada-Latn": {
        locale: "ada-Latn",
        displayName: "Adangme Latin"
    },
    yo: {
        locale: "yo",
        displayName: "Yoruba"
    },
    "ve-Latn": {
        locale: "ve-Latn",
        displayName: "Venda Latin"
    },
    "sc-Latn": {
        locale: "sc-Latn",
        displayName: "Sardinian Latin"
    },
    bo: {
        locale: "bo",
        displayName: "Tibetan"
    },
    "uz-Cyrl": {
        locale: "uz-Cyrl",
        displayName: "Uzbek Cyrillic"
    },
    naq: {
        locale: "naq",
        displayName: "Nama"
    },
    xh: {
        locale: "xh",
        displayName: "Xhosa"
    },
    "gaa-Latn": {
        locale: "gaa-Latn",
        displayName: "Ga Latin"
    },
    ta: {
        locale: "ta",
        displayName: "Tamil"
    },
    "awa-Deva": {
        locale: "awa-Deva",
        displayName: "Awadhi Devanagari"
    },
    "tt-Cyrl": {
        locale: "tt-Cyrl",
        displayName: "Tatar Cyrillic"
    },
    "ace-Latn": {
        locale: "ace-Latn",
        displayName: "Achinese Latin"
    },
    ln: {
        locale: "ln",
        displayName: "Lingala"
    },
    lou: {
        locale: "lou",
        displayName: "Louisiana Creole"
    },
    ti: {
        locale: "ti",
        displayName: "Tigrinya"
    },
    eu: {
        locale: "eu",
        displayName: "Basque"
    },
    nus: {
        locale: "nus",
        displayName: "Nuer"
    },
    "nv-Latn": {
        locale: "nv-Latn",
        displayName: "Navajo Latin"
    },
    "li-Latn": {
        locale: "li-Latn",
        displayName: "Limburgish Latin"
    },
    "ban-Latn": {
        locale: "ban-Latn",
        displayName: "Balinese Latin"
    },
    sn: {
        locale: "sn",
        displayName: "Shona"
    },
    mg: {
        locale: "mg",
        displayName: "Malagasy"
    },
    rm: {
        locale: "rm",
        displayName: "Romansh"
    },
    sw: {
        locale: "sw",
        displayName: "Swahili"
    },
    om: {
        locale: "om",
        displayName: "Oromo"
    },
    "ilo-Latn": {
        locale: "ilo-Latn",
        displayName: "Ilokano Latin"
    },
    "gez-Ethi": {
        locale: "gez-Ethi",
        displayName: "Ge'ez Ethiopic"
    },
    bem: {
        locale: "bem",
        displayName: "Bemba"
    },
    "fj-Latn": {
        locale: "fj-Latn",
        displayName: "Fijian Latin"
    },
    "yue-Hant": {
        locale: "yue-Hant",
        displayName: "Cantonese Traditional"
    },
    "hi-Latn": {
        locale: "hi-Latn",
        displayName: "Hindi Latin"
    },
    "pau-Latn": {
        locale: "pau-Latn",
        displayName: "Palauan Latin"
    },
    "syr-Syrc": {
        locale: "syr-Syrc",
        displayName: "Syriac Syriac"
    },
    "scn-Latn": {
        locale: "scn-Latn",
        displayName: "Sicilian Latin"
    },
    "ch-Latn": {
        locale: "ch-Latn",
        displayName: "Chamorro Latin"
    },
    gu: {
        locale: "gu",
        displayName: "Gujarati"
    },
    "dzg-Latn": {
        locale: "dzg-Latn",
        displayName: "Dazaga Latin"
    }
};
export const rthLanguages = new Set([
    "ar",
    "he",
    "fa",
    "ur",
    "ps",
    "uz-Arab",
    "ks-Arab",
    "pa-Arab",
    "ckb-Arab",
    "ms-Arab"
]);
export const SWLocalizationLanguages = Object.entries(languagesWithoutisRTL).reduce((acc, [locale, lang])=>{
    return {
        ...acc,
        [locale]: {
            ...lang,
            isRTL: rthLanguages.has(locale)
        }
    };
}, {});
